# frozen_string_literal: true

module Engine
  module Game
    module G1824Cisleithania
    end
  end
end
